require('./globals')

// Initialize Redux
window.booqableStore = require('./redux/store').default

window.booqableGetStore = function () {
  return window.booqableStore
}

// Intialize App
require('./react/initializer')
require('shared/user_framework')
require('shared/cookie_notice')
